module.exports = __webpack_public_path__ + "img/list_page_second.fc6256a7.png";